<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isDOAManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Manage Service Center Inventory | Service Manager</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
<div class="col-lg-10 center center-block" align="center">
	<div class="card card-primary card-outline">
		<div class="card-header">
			
		</div>
		<div class="card-body overflow-auto">
			<div class="col-md-10 float-left">
			<div class="row">
				
      	
      </div>
      </div>
      
			<!-- content here -->

    </div>
    <div class="card-footer">
    	
		</div>
	</div>
</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isDOAManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
